import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { compose } from "redux";
import { connect } from "react-redux";
import ReactModal from "react-modal";
// i18n
import { withNamespaces, Trans } from "react-i18next";
// Helpers
import cuid from "cuid";
// Form
import { Field, reduxForm, getFormValues } from "redux-form";
// Styles
import styles from "./VoucherOverlay.css";

import { required, length36 } from "../../../../../services/validators";
// Components
import Input from "../../../../../components/Input";
import Notice from "../../../../../components/Notice/Notice";
// Ducks
import { resetBookingState } from "../../ExamDetails.ducks";
import stylesModal from "../../../../../components/Modal/Modal.css";
import "../../../../../components/Modal/styles.css";
import { validateVoucher } from "../../../Vouchers/Vouchers.ducks";

ReactModal.setAppElement(`#root`);

class VoucherOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherInputs: [cuid()],
      validFormat: undefined,
      validCurrency: undefined,
      remainingAmount: undefined,
      duplicatedVouchers: undefined
    };
  }

  handleInputRemoveClick = (input) => () => {
    const { change } = this.props;
    const { voucherInputs } = this.state;

    const newState = voucherInputs.filter((i) => input !== i);

    // remove the voucher input from the redux-form
    change(input, ``);

    this.setState({
      voucherInputs: newState
    });
  };

  componentDidUpdate = (prevProps) => {
    const { formValues } = this.props;
    if (formValues !== prevProps.formValues) {
      this.validateVouchers();
    }
  };

  handleInputAddClick = () => {
    this.setState((prevState) => ({
      voucherInputs: [...prevState.voucherInputs, cuid()],
      duplicatedVouchers: undefined
    }));
  };

  handleCloseModal = (event) => {
    const { closeModal } = this.props;

    if (event.target === event.currentTarget) {
      event.stopPropagation();
      return closeModal && closeModal();
    }
  };

  validateVouchers = () => {
    const { examinationParts, formValues, validateVoucher } = this.props;

    const voucherCodes = Object.values(formValues);

    if (formValues) {
      const examinationPartIds = examinationParts.map((e) => e.examPartId);
      const duplicates = voucherCodes.filter(
        (i) => voucherCodes.filter((ii) => ii === i).length > 1
      ).length;
      if (
        Object.keys(voucherCodes).length &&
        !duplicates &&
        voucherCodes.every((i) => i.length === 36)
      ) {
        validateVoucher({
          examinationPartIds,
          voucherCodes
        }).then(() => {
          this.updateStateResult();
        });
      } else {
        this.setState({
          duplicatedVouchers: !!duplicates,
          validFormat: undefined,
          validCurrency: undefined,
          remainingAmount: undefined
        });
      }
    }
  };

  updateStateResult = () => {
    const { voucherValidationResult } = this.props;
    if (voucherValidationResult.results !== undefined) {
      let validFormat;
      let validCurrency;

      voucherValidationResult.results.every((i) => i.isValid === true)
        ? (validFormat = true)
        : (validFormat = false);

      voucherValidationResult.results.every((i) => i.hasDifferentCurrency === false)
        ? (validCurrency = true)
        : (validCurrency = false);

      const { remainingAmount } = voucherValidationResult;

      this.setState({
        validFormat,
        validCurrency,
        remainingAmount,
        duplicatedVouchers: false
      });
    }
  };

  render() {
    const {
      closeModal,
      examDetails,
      handleSubmit,
      isOpen,
      onSubmit,
      resetBookingState,
      t,
      title,
      valid,
      currency
    } = this.props;
    const {
      voucherInputs,
      validFormat,
      validCurrency,
      remainingAmount,
      duplicatedVouchers
    } = this.state;

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{
          content: stylesModal.content,
          overlay: stylesModal.overlay
        }}
      >
        <div className="modal-header">
          <button
            aria-hidden="true"
            className="close"
            data-dismiss="modal"
            onClick={this.handleCloseModal}
            type="button"
          >
            &times;
          </button>
          <h4 className="modal-title" id="myModalLabel">
            {title}
          </h4>
        </div>
        <div className="modal-body">
          <form
            autoComplete="off"
            className="smart-form"
            id="checkout-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <fieldset style={{ padding: 0 }}>
              {voucherInputs.map((input, index) => (
                <div key={input} style={styles.inputContainer}>
                  <Field
                    component={Input}
                    iconClass="icon-append fa fa-credit-card"
                    name={input}
                    placeholder={t(
                      `modules.localization.register.authenticated.vouchers.label.voucher`
                    )}
                    validate={[required, length36]}
                    onChange={this.handleChange}
                  />
                  <button
                    className="btn"
                    onClick={index ? this.handleInputRemoveClick(input) : this.handleInputAddClick}
                    style={styles.inputButton}
                    type="button"
                  >
                    <i
                      className={classNames(`fa`, {
                        "fa-plus-circle": !index,
                        "fa-minus-circle": index
                      })}
                      style={styles.icon}
                    />
                  </button>
                </div>
              ))}
            </fieldset>
            {remainingAmount > 0 && validFormat && (
              <div style={styles.messageContainer}>
                <Trans
                  i18nKey="modules.localization.register.authenticated.vouchers.remainingAmount"
                  values={{
                    remainingAmount,
                    currency
                  }}
                >
                  <b>
                    {t(`modules.localization.register.authenticated.vouchers.remainingAmount`)}:
                  </b>
                </Trans>
              </div>
            )}
            {validFormat === false && (
              <div style={styles.errorContainer}>
                {t(`modules.localization.register.authenticated.vouchers.invalidFormat`)}
              </div>
            )}
            {validCurrency === false && (
              <div style={styles.errorContainer}>
                {t(`modules.localization.register.authenticated.vouchers.differentCurrency`)}
              </div>
            )}
            {duplicatedVouchers && (
              <div style={styles.errorContainer}>
                {t(`modules.localization.register.authenticated.vouchers.duplicatedVouchers`)}
              </div>
            )}
            {examDetails.error && (
              <div style={styles.errorContainer}>
                <Notice clearMessage={resetBookingState} title={examDetails.error} type="danger" />
              </div>
            )}
          </form>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-primary"
            disabled={
              !valid || !validFormat || !validCurrency || duplicatedVouchers || remainingAmount
            }
            onClick={handleSubmit(onSubmit)}
            type="button"
          >
            {t(`modules.localization.register.authenticated.vouchers.redeem`)}
          </button>
        </div>
      </ReactModal>
    );
  }
}

VoucherOverlay.defaultProps = {
  onSubmit: () => {}
};

VoucherOverlay.propTypes = {
  closeModal: PropTypes.func.isRequired,
  examDetails: PropTypes.shape({
    error: PropTypes.string
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
  resetBookingState: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  examinationParts: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  formValues: PropTypes.objectOf(PropTypes.string).isRequired,
  voucherValidationResult: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    remainingAmount: PropTypes.number
  }).isRequired,
  validateVoucher: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  examDetails: state.examDetails,
  voucherValidationResult: state.vouchers.voucherValidation,
  formValues: getFormValues(`voucher`)(state) || {}
});

export default compose(
  connect(
    mapStateToProps,
    { resetBookingState, validateVoucher }
  ),
  reduxForm({
    form: `voucher`
  }),
  withNamespaces()
)(VoucherOverlay);
